var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu h-100 instantaneousData",on:{"click":_vm.onClickArea}},[(_vm.subMenu === 'battery')?_c('h4',[_vm._v("Battery voltage")]):_vm._e(),(_vm.subMenu === 'battery')?_c('ScaniaNextGenBar',_vm._b({},'ScaniaNextGenBar',{
        min: 20,
        max: 36,
        value: _vm.telemetry2.truck.batteryVoltage,
        unit: 'V',
        displayMidLabel: false
      },false),[_c('i',{staticClass:"icon icon-scania-battery_red"})]):_vm._e(),(_vm.subMenu === 'pressure')?_c('h4',[_vm._v("Brake pressure")]):_vm._e(),(_vm.subMenu === 'pressure')?_c('ScaniaNextGenBar',_vm._b({staticClass:"py-1"},'ScaniaNextGenBar',{
        min: 0,
        max: 175,
        value: _vm.telemetry2.truck.brakeAirPressure,
        unit: _vm.$unitReadable('unit_pressure')
      },false),[_c('i',{staticClass:"icon icon-scania-parking-break_red"})]):_vm._e(),(_vm.subMenu === 'adBlue')?_c('h4',[_vm._v("Ad blue")]):_vm._e(),(_vm.subMenu === 'adBlue')?_c('ScaniaNextGenBar',_vm._b({},'ScaniaNextGenBar',{
        min: 0,
        max: 100,
        value:
          (_vm.telemetry2.truck.adBlueLevel * 100) /
          _vm.telemetry2.truck.adBlueCapacity,
        unit: '%'
      },false),[_c('i',{staticClass:"icon icon-scania-ad-blue-low_yellow"})]):_vm._e(),_c('div',{staticClass:"subMenuIndicator"},[_c('div',{staticClass:"square",class:{ active: _vm.subMenu === 'battery' }}),_c('div',{staticClass:"square",class:{ active: _vm.subMenu === 'pressure' }}),_c('div',{staticClass:"square",class:{ active: _vm.subMenu === 'adBlue' }})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }